'use strict';

module.exports = '3.24.11';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 599
// module chunks = 142807904292071